module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "layout-header"
  }, [_c('ul', {
    staticClass: "ngui2-nav"
  }, [_c('li', {}, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("欢迎你，" + _vm._s(_vm.userInfo.name))])]), _vm._v(" "), _c('li', [(['production', 'staging'].includes(_vm.env)) ? _c('span', [_c('a', {
    staticClass: "logout",
    attrs: {
      "href": "https://sso.sankuai.com/logout"
    }
  }, [_vm._v("退出")])]) : _c('span', [_c('a', {
    staticClass: "logout",
    attrs: {
      "href": "http://develop.sso.test.sankuai.info/logout"
    }
  }, [_vm._v("退出")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76819af2","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/NavBar.vue
// module id = 955
// module chunks = 0